// @flow
import ActivityReport from './ActivityReport';

export default ActivityReport;
